import { render, staticRenderFns } from "./mn.vue?vue&type=template&id=3ffb650a&scoped=true&"
import script from "./mn.vue?vue&type=script&lang=js&"
export * from "./mn.vue?vue&type=script&lang=js&"
import style0 from "./mn.vue?vue&type=style&index=0&id=3ffb650a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb650a",
  null
  
)

export default component.exports